import React from 'react';
import { Box } from '@mui/system';
import { IPointOfSaleSettingsProps } from 'components/settings/PointOfSaleSettings';
import { TextFormField } from 'lib/form/fields/TextFormField';
import { SwitchFormField } from 'lib/form/fields/SwitchFormField';
import { SettingDisplay } from 'lib/SettingDisplay';
import { DictionaryFormField } from 'lib/form/fields/DictionaryFormField';
import { OrderScenario, OrderScenarioOptions } from 'components/order/model/Order';

const accountProfileScenarios: string[] = [
    OrderScenario.PREORDER,
    OrderScenario.TAKE_OUT,
    OrderScenario.DELIVERY
];
const accountProfileScenarioOptions = OrderScenarioOptions.filter(o =>
    accountProfileScenarios.includes(o.value)
);

export const LightspeedKSeriesSettingsEdit: React.FC<IPointOfSaleSettingsProps> = ({ locationId }) => (
    <>
        {locationId === undefined && (
            <>
                <SettingDisplay label="Host">
                    <TextFormField name="lightspeedKSeriesHost" />
                </SettingDisplay>
                <SettingDisplay label="Webhooks Enabled">
                    <SwitchFormField name="lightspeedKSeriesWebhooksEnabled" />
                </SettingDisplay>
            </>
        )}

        {locationId !== undefined && (
            <>
                <SettingDisplay label="Business Location ID">
                    <TextFormField name="lightspeedKSeriesLocationId" />
                </SettingDisplay>
                <SettingDisplay label="Payment Method Code">
                    <TextFormField name="lightspeedKSeriesPaymentMethodCode" />
                </SettingDisplay>
                <Box sx={{ mt: 2 }}>
                    <SettingDisplay label="Account Profile Code Mapping">
                        <DictionaryFormField
                            name="lightspeedKSeriesScenarioToAccountProfileCode"
                            keyConfig={{ variant: 'singleSelect', options: accountProfileScenarioOptions }}
                            valueConfig={{ variant: 'text', placeholder: 'Account profile code' }}
                            addButtonLabel="Add scenario"
                        />
                    </SettingDisplay>
                </Box>
            </>
        )}
    </>
);
